import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ChannelDirectoryCreateModal from './ChannelDirectoryCreateModal'
import { actions, types } from '../../../store'

const mapStateToProps = state => ({
  status: state.modal.channelDirectoryCreateModal.status,
  id: state.modal.channelDirectoryCreateModal.id
})

const mapDispatchToProps = dispatch => bindActionCreators({
  closeModal: () => actions.modal.setModal(types.MODAL_STORAGE_DIRECTORY_CREATE, { status: false, id: null }),
  createStorageDirectoryById: actions.storage.createStorageDirectoryById
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChannelDirectoryCreateModal)



// WEBPACK FOOTER //
// ./src/components/Modals/ChannelDirectoryCreateModal/index.js